module.exports = __webpack_public_path__ + "img/tangshan-827dea.png";